import { render } from "./MarketPlaceApp.vue?vue&type=template&id=d1d5e842&scoped=true"
import script from "./MarketPlaceApp.vue?vue&type=script&lang=js"
export * from "./MarketPlaceApp.vue?vue&type=script&lang=js"

import "./MarketPlaceApp.vue?vue&type=style&index=0&id=d1d5e842&scoped=true&lang=css"
import "./MarketPlaceApp.vue?vue&type=style&index=1&id=d1d5e842&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d5e842"]])

export default __exports__